import React, { FunctionComponent, useState, useEffect, useCallback } from 'react';
import _debounce from 'lodash/debounce';

import Icon from '../Icons';

import { InputWithIcon } from './styles';

const SearchInput: FunctionComponent<{
  handleChange: Function;
  onEnter: Function;
  placeholder: string;
  handleBlur: Function;
  value?: string;
  // showIcon?: boolean;
  // referenceClass?: string;
}> = ({ handleChange, placeholder, onEnter, handleBlur, value = '' }) => {
  const [searchText, setSearchText] = useState(value);
  const [firstLoad, toggleFirstLoad] = useState(false);

  useEffect(() => {
    setSearchText(value || '');
  }, [value]);

  const focusHandler = React.useCallback(
    (ev: any) => {
      if (searchText) {
        handleBlur(searchText);
      }
    },
    // TODO: handle dependencies handleBlur
    // eslint-disable-next-line react-hooks/exhaustive-deps
    [searchText],
  );

  const handleKeyPress = (event: any) => {
    if (event && event.keyCode === 13) {
      event.target.blur();
    }
  };

  const delayedQuery = useCallback(
    _debounce(() => handleBlur(searchText), 1000),
    [searchText],
  );

  useEffect(() => {
    if (!firstLoad) {
      return;
    }
    delayedQuery();
    // Cancel the debounce on useEffect cleanup.
    return delayedQuery.cancel;
  }, [firstLoad, searchText, delayedQuery]);

  const changeHandler = (event: any) => {
    if (!firstLoad) {
      toggleFirstLoad(true);
    }
    const value = event.target.value;
    setSearchText(value);
  };

  const clearText = (e: any) => {
    handleBlur('');
  };
  // const unloadingPointsClassName = referenceClass || '';
  return (
    <InputWithIcon className={`flex falign-c`} id="search-input">
      {/* {showIcon && ( */}
      <span className="flex-1 flex falign-c">
        <Icon name="search" />
      </span>
      {/* )} */}

      <input
        className="flex-9 small"
        onKeyDown={handleKeyPress}
        onChange={(e) => changeHandler(e)}
        placeholder={placeholder}
        onBlur={focusHandler}
        value={searchText}
      />
      {searchText ? (
        <button type="button" className="clear" onClick={(e) => clearText(e)}>
          &times;
        </button>
      ) : null}
    </InputWithIcon>
  );
};

export default SearchInput;
